import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    style: { "height": "70px" },
    class: "w-full items-center justify-center flex space-x-4"
};
import { Reflect01Icon, RefreshCcw01Icon, RefreshCw01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CropSubTool',
    props: {
        canvasCtx: {
            type: Object,
            require: true,
        },
        cropper: {
            type: Object,
            require: true,
        },
    },
    emits: ['cropChange'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const rotationAngle = ref(0);
        function flipObject(flipType) {
            let x = true;
            let y = false;
            let flip = 'flipX';
            if (flipType === 'vertical') {
                x = false;
                y = true;
                flip = 'flipY';
            }
            props.cropper.flip(x, y);
            emits('cropChange', { flip });
        }
        function rotateObject(angle) {
            props.cropper.rotate(angle);
            emits('cropChange', { angle });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Reflect01Icon), {
                    class: "w-5 h-5 text-gray-700 cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = ($event) => (flipObject('horizontal')))
                }),
                _createVNode(_unref(Reflect01Icon), {
                    class: "w-5 h-5 text-gray-700 cursor-pointer",
                    style: { "transform": "rotate(90deg)" },
                    onClick: _cache[1] || (_cache[1] = ($event) => (flipObject('vertical')))
                }),
                _createVNode(_unref(RefreshCcw01Icon), {
                    class: _normalizeClass([
                        rotationAngle.value == -180 ? 'disable cursor-not-allowed text-gray-400' : '',
                        "w-5 h-5 text-gray-700 cursor-pointer"
                    ]),
                    onClick: _cache[2] || (_cache[2] = ($event) => (rotateObject(-90)))
                }, null, 8, ["class"]),
                _createVNode(_unref(RefreshCw01Icon), {
                    class: _normalizeClass([
                        rotationAngle.value == 180 ? 'disable cursor-not-allowed text-gray-400' : '',
                        "w-5 h-5 text-gray-700 cursor-pointer"
                    ]),
                    onClick: _cache[3] || (_cache[3] = ($event) => (rotateObject(90)))
                }, null, 8, ["class"])
            ]));
        };
    }
});
